import { useRef, useMemo } from 'react';
const usePreviousValue = (value) => {
    const previous = useRef(value);
    const previousValue = previous.current;
    previous.current = value;
    return previousValue;
};
export const useMutableQueue = () => {
    const queue = useRef([]);
    const methods = useMemo(() => {
        return {
            push(payload) {
                queue.current.push(payload);
            },
            flush(callback) {
                for (const item of queue.current) {
                    callback(item);
                }
                queue.current.length = 0;
            },
        };
    }, []);
    return methods;
};
const useEquals = (value) => {
    const previousValue = usePreviousValue(value);
    return previousValue === value;
};
export const useSafeTrackerProvider = (provider) => {
    const pageViewQueue = useMutableQueue();
    const eventQueue = useMutableQueue();
    const installed = useRef(false);
    const isProviderEquals = useEquals(provider);
    const safe = useMemo(() => {
        return {
            install() {
                installed.current = true;
                provider.install();
                pageViewQueue.flush(provider.trackPageView);
                eventQueue.flush(provider.trackEvent);
            },
            uninstall() {
                provider.uninstall();
            },
            trackPageView(payload) {
                if (installed.current) {
                    provider.trackPageView(payload);
                }
                else {
                    pageViewQueue.push(payload);
                }
            },
            trackEvent(payload) {
                if (installed.current) {
                    provider.trackEvent(payload);
                }
                else {
                    eventQueue.push(payload);
                }
            },
        };
    }, [provider, pageViewQueue, eventQueue]);
    if (!isProviderEquals) {
        installed.current = false;
    }
    return safe;
};
